import { ElectronApi } from '@/services/electron.api';

export const getWebBuildTime = () => {
  const buildTime = 'build-time';
  const metas: HTMLMetaElement[] = [].slice.call(
    document.head.getElementsByTagName('meta')
  );
  const content = metas.find((meta) => meta.name == buildTime)?.content;
  return content;
};

export const getEditorVersion = async () => {
  const res = await ElectronApi.getAppInfo();
  return res.version;
};
